@if (!hideControls) {
    <div>
        <mat-checkbox class="pe-3" [formControl]="fcMaintainAspectRatioControl"> Toon in verhouding </mat-checkbox>
        <mat-checkbox [formControl]="fcNoOverScaleControl"> Niet schalen boven resolutie </mat-checkbox>
    </div>
}
<div class="img-input">
    <button class="from-link" (click)="loadLinkDialog()" mat-icon-button color="primary">
        <mat-icon class="fas fa-link"></mat-icon>
    </button>
    <label
        [class.empty]="fcImage?.value?.length < 3"
        [class.loading]="loading"
        [class.movable]="!!fcOffsetX"
        [class.moving]="moving"
        [style.height.px]="height"
        [style.width.px]="width"
        (click)="labelClick($event)">
        @if (!outputBase64) {
            <app-codalt-image
                [fullUrl]="fcImage?.value"
                [maintainAspectRatio]="fcMaintainAspectRatio?.value"
                [noOverScale]="fcNoOverScale?.value"
                [offsetPercX]="fcOffsetX?.value"
                [offsetPercY]="fcOffsetY?.value"
                [thumb]="fcImage?.value"></app-codalt-image>
        } @else {
            <app-codalt-image></app-codalt-image>
        }
        <input #fileInput (change)="submit($event); fileInput.value = ''" hidden type="file" />
        @if (fcOffsetX) {
            <div
                class="move"
                (click)="$event.stopPropagation(); $event.preventDefault()"
                (panend)="panEnd()"
                (panmove)="panMove($event)"
                (panstart)="panStart()"></div>
        }
        <div class="spinner">
            <mat-spinner></mat-spinner>
        </div>
    </label>
</div>
<ng-template #insertLinkTemplate>
    <div class="dialog-header" mat-dialog-title>
        <span>Afbeelding invoegen</span>
        <button class="close-button" (click)="linkDialog.close()" mat-icon-button>
            <mat-icon class="fas fa-times"></mat-icon>
        </button>
    </div>

    <div class="dialog-content" mat-dialog-content>
        <mat-form-field class="w-100" appearance="outline">
            <mat-label>Url</mat-label>
            <input [(ngModel)]="linkInput" matInput />
        </mat-form-field>
    </div>

    <div class="d-flex justify-content-end action-buttons" mat-dialog-actions>
        <button class="cancel-button" (click)="linkDialog.close()" mat-button>Annuleren</button>
        <button class="confirm-button" (click)="linkDialog.close(linkInput)" mat-raised-button color="primary">
            Toevoegen
        </button>
    </div>
</ng-template>
